import Vue from 'vue'
import App from './App.vue'
import router from './router'

const firebaseConfig = {
  apiKey: "AIzaSyB7NE8Munbt4D06BNTmTZhcW2vPhKi96ls",
  authDomain: "allappsvirtual.firebaseapp.com",
  databaseURL: "https://allappsvirtual-default-rtdb.firebaseio.com",
  projectId: "allappsvirtual",
  storageBucket: "allappsvirtual.appspot.com",
  messagingSenderId: "1026555739198",
  appId: "1:1026555739198:web:0e92fc0f738fdc4c33e56f"
};



firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false

Vue.prototype.$score = {}

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
